import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType, DurationUnits } from '../base/baseSchema.js';
import { BlockValueTemplateDurationSchema } from '../base/blockValueTemplateDurationSchema.js';

export enum MirthMessageType {
  Hl7 = 'Hl7',
  Json = 'Json',
  X12 = 'X12',
}

export const maximumTimeoutDuration = {
  value: 20,
  units: DurationUnits.Minutes,
};

export const MirthBlockConfigSchema = z.object({
  messageType: z.nativeEnum(MirthMessageType),
  message: z.string(),
  path: z.string().optional().default('/'),
  timeout: BlockValueTemplateDurationSchema({
    pathName: 'timeout',
    maxDuration: maximumTimeoutDuration,
  })
    .optional()
    .default({
      value: '45',
      units: DurationUnits.Seconds,
    }),
});

export type MirthBlockConfig = z.infer<typeof MirthBlockConfigSchema>;

export const MirthBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Mirth),
  config: MirthBlockConfigSchema,
});

export type MirthBlock = z.infer<typeof MirthBlockSchema>;
